import { Alert, Col, Form, Row } from "antd";
import { MazakaRangePicker } from "apps/Common/MazakaRangePicker";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import Search from "./Search";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { handleSetNewsFilter } from "../ClientSideStates";
import { FC, ReactNode } from "react";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaButton } from "apps/Common/MazakaButton";
import { FilterOutlined } from "@ant-design/icons";

const WrapperForm:FC<{isUseLabel:boolean,children:any, }> = ({isUseLabel,children})=>{
  const [form] = Form.useForm()
  return(
    <>
    {
      isUseLabel?<>
      <MazakaForm submitButtonVisible={false}  form={form} >
      {children}
      </MazakaForm>
      
      </>:<>
      {
        children
      }
      </>
    }
    </>
  )

}

const TopImportantFilters:FC<{isUseLabel:boolean,setIsShowMobileDrawerFilter:any}> = ({isUseLabel,setIsShowMobileDrawerFilter}) => {
  const { filter } = useSelector((state: RootState) => state.news);
  const dispatch = useDispatch();
  const handleDateChange = (dates: any) => {
    if (!dates) {
      const currentFilter = { ...filter };
      delete currentFilter["StartDate"];
      delete currentFilter["EndDate"];
      dispatch(handleSetNewsFilter({ filter: currentFilter }));
      return;
    }

    const currentFilter = { ...filter };

    const startDate = dates[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null;
    const endDate = dates[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null;

    if (startDate) {
      currentFilter["StartDate"] = startDate;
    } else {
      delete currentFilter["StartDate"];
    }

    if (endDate) {
      currentFilter["EndDate"] = endDate;
    } else {
      delete currentFilter["EndDate"];
    }

    dispatch(handleSetNewsFilter({ filter: currentFilter }));
  };

  const handleChangeCategory = (value: string | undefined) => {
    const currentFilter = { ...filter };
    if (value) {
      currentFilter["CategoryId"] = value;
    } else {
      delete currentFilter["CategoryId"];
    }
    dispatch(handleSetNewsFilter({ filter: currentFilter }));
  };

  return (
    <>
      <Row>
        
        <Col xs={24}>
        <WrapperForm isUseLabel={isUseLabel} >

          <Row gutter={[10, 10]}>
          {
              isUseLabel&&
              <Col xs={24} >
                 <Alert message="Filtreler seçim yapıldığında otomatik uygulanır" className="!text-xs sm:!text-sm" type="info"  />
              </Col>
            }
            
            <Col xs={24}  lg={6}>
              <Search isUseLabel={isUseLabel} />
            </Col>
            <MazakaSelect
              allowClear
              name={"CategoryId"}
            label={isUseLabel?"Kategori":""}
              placeholder="Kategori"
              onChange={handleChangeCategory}
              xs={24}
             
              lg={6}
              options={[
                { label: "Gayrimenkul", value: 1 },
                { label: "Araç", value: 502 },
              ]}
            />

            <MazakaRangePicker
              onChange={handleDateChange}
              name={"Tarih"}
             
              label={isUseLabel?"Tarih Aralığı":""}
              LeftPlaceHolder="Min Tarih"
              RightPlaceHolder="Maks Tarih"
              xs={24}
             
              lg={8}
            />
            
          </Row>
        </WrapperForm>
        </Col>
      </Row>
    </>
  );
};

export default TopImportantFilters;
